import { TableCell, TableRow } from "style/components";
import { Icon } from "@evertrue/et-components";
import React from "react";
import PropTypes from "prop-types";

const JourneyGroupsTableRow = ({ group = {} }) => {
  const { name = "" } = group;

  return (
    <TableRow>
      <TableCell>{name}</TableCell>
      <TableCell>
        <Icon
          icon="more-horiz"
          style={{ cursor: "pointer", fontSize: "24px" }}
        />
      </TableCell>
    </TableRow>
  );
};

JourneyGroupsTableRow.propTypes = {
  group: PropTypes.object.isRequired,
};

export default JourneyGroupsTableRow;
